import { render, staticRenderFns } from "./gridCard.vue?vue&type=template&id=369b349c&scoped=true&"
import script from "./gridCard.vue?vue&type=script&lang=js&"
export * from "./gridCard.vue?vue&type=script&lang=js&"
import style0 from "./gridCard.vue?vue&type=style&index=0&id=369b349c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b349c",
  null
  
)

export default component.exports